// @core/api/endpoints/localization/create_translation_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTranslationKeyRequest,
  TranslationKeyResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Create translation key
 * Creates a new translation key in a namespace with source text.
 */
export async function CreateTranslationKey(
  data: CreateTranslationKeyRequest,
  options?: RequestOptions
): Promise<TranslationKeyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/keys`;
  const requestOptions = options;
  return client.post<TranslationKeyResponse>(requestPath, data, requestOptions);
}
